import React from 'react';
import './Square.css';

interface SquareProps {
  variantNames: string[];
}

function Square(props: SquareProps) {
  const classNames = ['square'];
  props.variantNames.forEach(variant => {
    classNames.push(`${classNames[0]}--${variant}`);
  });
  return (
    <div className={classNames.join(' ')}>
    </div>
  );
}

export default Square;